import { createContext, Dispatch, SetStateAction } from "react";

import { GridReadyEvent } from "ag-grid-community";

export default createContext<{
  gridEvent?: GridReadyEvent;
  setGridEvent?: Dispatch<SetStateAction<GridReadyEvent | undefined>>;
}>({});
